export default __webpack_public_path__ + "static/media/video.52107d23.svg";